import gql from 'graphql-tag';

export default gql`
  fragment adminDoorKeyFragment on AdminDoorKeyType {
    id
    keyNumber
    target
    targetName
    reservationNumber
    eventId
    url
    guestName
    guestEmail
    spaceName
    status
    issuedAt
    mailSentAt
    lastUnlockedAt
    revokedAt
    revokedByName
    reissuable
    windows {
      unlockText
      useText
    }
    activities {
      id
      createdAt
      actionName
      actorName
      succeeded
      detail
    }
  }
`;
